import React from "react"
import { Col, Row } from "reactstrap"
import CustomDateTime from "../../../../components/Common/CustomDateTime"
import CustomSelect from "../../../../components/Common/CustomSelect"
import { getLabelFromArray } from "../../../../helpers/array_utils"
import { DOCUMENTTYPE_ENUM } from "../../../Core/Partner/components/consts"
import { partnerModal } from "../../../Core/Partner/components/PartnerModal"

const BaseFormSale = props => {
  const { form, disabled, internalType, readOnlyStates } = props

  return (
    <React.Fragment>
      <Col md="4">
        <Row>
          <Col md="12" lg="6">
            <CustomSelect
              key={JSON.stringify(
                internalType + (form.fields?.partner?.id ?? 0)
              )}
              label="Comprobante"
              {...form?.getSelect(
                "accountInvoiceType",
                "accountInvoiceType",
                `internalType=${internalType}&partner=${form.fields?.partner?.id}`
              )}
              isDisabled={
                disabled || readOnlyStates.includes(form.fields?.invoiceState)
              }
              required
            />
          </Col>
          <Col md="12" lg="6">
            <CustomSelect
              label="Punto de venta"
              {...form?.getSelect("posConfig", "posConfig")}
              isDisabled={
                disabled || readOnlyStates.includes(form.fields?.invoiceState)
              }
            />
          </Col>
        </Row>

        <CustomSelect
          label={`Cliente ${
            form.fields?.partner
              ? `[${getLabelFromArray(
                  form.fields?.partner?.documentType,
                  DOCUMENTTYPE_ENUM
                )} - ${form.fields?.partner?.document}]`
              : ""
          }`}
          {...form?.getSelect(
            "partner",
            "partner",
            "partnerType=1",
            partnerModal,
            { active: true, customer: true }
          )}
          isDisabled={
            disabled || readOnlyStates.includes(form.fields?.invoiceState)
          }
          required
        />
      </Col>

      <Col md="4">
        <CustomDateTime
          label="Fecha de la factura"
          disabled={
            disabled || readOnlyStates.includes(form.fields?.invoiceState)
          }
          {...form?.getInputDate("date", "dateInvoice")}
        />

        <CustomSelect
          label="Diario"
          {...form?.getSelect(
            "accountJournal",
            "accountJournal",
            "types=1&forInvoice=true"
          )}
          required
          isDisabled={
            disabled || readOnlyStates.includes(form.fields?.invoiceState)
          }
        />

        <Row>
          <Col md="12" lg="6">
            <CustomSelect
              label="Plazos de pago"
              {...form?.getSelect("accountPaymentTerm", "accountPaymentTerm")}
              required
              isDisabled={
                disabled ||
                readOnlyStates.includes(form.fields?.invoiceState) ||
                form.fields?.partner === null
              }
            />
          </Col>
          <Col md="12" lg="6">
            <CustomDateTime
              label="Fecha vencimiento"
              disabled={
                disabled || readOnlyStates.includes(form.fields?.invoiceState)
              }
              {...form?.getInputDate("date", "dueInvoice")}
            />
          </Col>
        </Row>
      </Col>
    </React.Fragment>
  )
}

export default BaseFormSale
